<div class="notification">
  <div class="notification-header">
    <div class="header-box">
      <div class="creation-time">{{notification.creationTime | wmCalendarFormat }}</div>
      @if (isWmAdminNotification(notification) || notification.creator) {
        <wm-avatar [webmateIcon]="isWmAdminNotification(notification)" [userId]="notification.creator" size="16"></wm-avatar>
      }
    </div>
  </div>
  <div class="notification-content" [ngClass]="{'global': isWmAdminNotification(notification)}">
    @if (moment(notification.creationTime).isAfter(seenDate)) {
      <div class="new-notification"></div>
    }
    <div class="title">{{notification.body.title}}</div>
    <div class="body ql-editor" [innerHTML]="bodyText"></div>
  </div>
</div>
